import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
const h = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const STATUS_COLOR = {
  active: '#10b981', trial: '#f59e0b', expired: '#ef4444', suspended: '#6b7280',
};
const STATUS_LABEL = {
  active: 'Faol', trial: 'Trial', expired: 'Muddati o\'tgan', suspended: 'To\'xtatilgan',
};

export default function SuperLabs() {
  const navigate = useNavigate();
  const [labs, setLabs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const limit = 20;

  const load = useCallback(() => {
    setLoading(true);
    const params = { page, limit, search, status: statusFilter };
    axios.get(`${API}/super/labs`, { ...h(), params })
      .then(r => { setLabs(r.data.labs); setTotal(r.data.total); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [page, search, statusFilter]);

  useEffect(() => { load(); }, [load]);

  const pages = Math.ceil(total / limit);

  return (
    <div style={{ maxWidth: 1200 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <div style={{ fontSize: 20, fontWeight: 900, color: '#f59e0b' }}>🏢 Barcha klublar</div>
          <div style={{ fontSize: 12, color: 'var(--text3)' }}>Jami: {total} ta</div>
        </div>
        <button onClick={() => navigate('/super/labs/new')} style={{
          background: 'rgba(245,158,11,0.15)', border: '1px solid #f59e0b',
          color: '#f59e0b', padding: '10px 20px', borderRadius: 10, cursor: 'pointer', fontWeight: 700,
        }}>➕ Yangi klub</button>
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        <input
          value={search} onChange={e => { setSearch(e.target.value); setPage(1); }}
          placeholder="Klub nomi yoki email qidirish..."
          style={{
            flex: 1, padding: '10px 14px', background: 'var(--bg2)',
            border: '1px solid var(--border)', borderRadius: 10, color: 'var(--text)', fontSize: 13,
          }}
        />
        <select value={statusFilter} onChange={e => { setStatusFilter(e.target.value); setPage(1); }} style={{
          padding: '10px 14px', background: 'var(--bg2)', border: '1px solid var(--border)',
          borderRadius: 10, color: 'var(--text)', fontSize: 13, cursor: 'pointer',
        }}>
          <option value="">Barcha statuslar</option>
          <option value="active">Faol</option>
          <option value="trial">Trial</option>
          <option value="expired">Muddati o'tgan</option>
          <option value="suspended">To'xtatilgan</option>
        </select>
      </div>

      {/* Table */}
      <div style={{ background: 'var(--bg2)', borderRadius: 14, border: '1px solid var(--border)', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid var(--border)' }}>
              {['Klub', 'Egasi', 'Kompyuterlar', 'Aktiv sessiya', 'Bugun daromad', 'Obuna', 'Tugash'].map(col => (
                <th key={col} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, color: 'var(--text3)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1 }}>
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ textAlign: 'center', padding: 40, color: 'var(--text3)' }}>Yuklanmoqda...</td></tr>
            ) : labs.length === 0 ? (
              <tr><td colSpan={7} style={{ textAlign: 'center', padding: 40, color: 'var(--text3)' }}>Klub topilmadi</td></tr>
            ) : labs.map(lab => (
              <tr
                key={lab.id}
                onClick={() => navigate(`/super/labs/${lab.id}`)}
                style={{ borderBottom: '1px solid var(--border)', cursor: 'pointer', transition: 'background 0.15s' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(245,158,11,0.04)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                <td style={{ padding: '14px 16px' }}>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>{lab.name}</div>
                  <div style={{ fontSize: 11, color: 'var(--text3)' }}>{lab.city || '—'}</div>
                </td>
                <td style={{ padding: '14px 16px', fontSize: 13, color: 'var(--text2)' }}>
                  {lab.owner_name}<br />
                  <span style={{ fontSize: 11, color: 'var(--text3)' }}>{lab.owner_email}</span>
                </td>
                <td style={{ padding: '14px 16px', fontWeight: 700 }}>{lab.computers_count || 0}</td>
                <td style={{ padding: '14px 16px', fontWeight: 700, color: lab.active_sessions > 0 ? '#10b981' : 'var(--text3)' }}>
                  {lab.active_sessions || 0}
                </td>
                <td style={{ padding: '14px 16px', fontWeight: 700, color: '#f59e0b' }}>
                  {Number(lab.revenue_today || 0).toLocaleString()}
                </td>
                <td style={{ padding: '14px 16px' }}>
                  <span style={{
                    padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700,
                    background: (STATUS_COLOR[lab.sub_status] || '#6b7280') + '22',
                    color: STATUS_COLOR[lab.sub_status] || '#6b7280',
                  }}>
                    {STATUS_LABEL[lab.sub_status] || lab.sub_status || '—'}
                  </span>
                </td>
                <td style={{ padding: '14px 16px', fontSize: 12, color: 'var(--text3)' }}>
                  {lab.sub_end ? new Date(lab.sub_end).toLocaleDateString('uz-UZ') : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {pages > 1 && (
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 20 }}>
          {Array.from({ length: pages }, (_, i) => i + 1).map(p => (
            <button key={p} onClick={() => setPage(p)} style={{
              width: 36, height: 36, borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 13,
              background: p === page ? 'rgba(245,158,11,0.2)' : 'var(--bg2)',
              border: `1px solid ${p === page ? '#f59e0b' : 'var(--border)'}`,
              color: p === page ? '#f59e0b' : 'var(--text2)',
            }}>{p}</button>
          ))}
        </div>
      )}
    </div>
  );
}
